import(/* webpackMode: "eager" */ "/home/runner/work/pensjonskalkulator-uinnlogget-frontend/pensjonskalkulator-uinnlogget-frontend/src/app/error.tsx");
